module.exports = __webpack_public_path__ + "static/media/215-Hochheben-ohne-Info_ID_1.f6f56ca8.mp3";